<template>
  <div class="sub-nav">
    <ul class="nav-warp sub-nav-warp">
      <li>
        <router-link to="/home" :class="name === 'home' ? 'active' : ''">鸡场</router-link>
      </li>
      <li>
        <router-link :to="`/${id}/devices`" :class="name === 'devices' ? 'active' : ''">设备</router-link>
      </li>
      <li>
        <router-link :to="`/${id}/audio`" :class="name === 'audio' ? 'active' : ''">声音</router-link>
      </li>
      <li>
        <router-link :to="`/${id}/health`" :class="name === 'health' ? 'active' : ''">健康指数</router-link>
      </li>
      <li>
        <router-link :to="`/${id}/liveness`" :class="name === 'liveness' ? 'active' : ''">活跃指数</router-link>
      </li>
      <li>
        <router-link :to="`/${id}/env`" :class="name === 'env' ? 'active' : ''">环境指数</router-link>
      </li>
      <li>
        <router-link :to="`/${id}/building`" :class="name === 'building' ? 'active' : ''">分栋</router-link>
      </li>
      <li v-if="userName === 'hjx'">
        <router-link :to="`/${id}/stat`" :class="name === 'stat' ? 'active' : ''">统计</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SubHeader',
  props: {
    id: Number,
    name: String
  },
  data() {
    return {
      
    }
  },
  mounted(){
    
  },
  watch: {
    // $route () {
    //   console.log('this.$route1111', this.$route)
    //   // this.currAct = this.$route.name
    //   this.currAct = this.$route.matched[0].name
    // }
  },
  computed: {
    userName () {
      return this.$store.state.user.userName
    },
  },
  methods: {
    
  },
  // created () {
  //   console.log(this.currHenneryId)
  // },
  beforeDestroy() {
    
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/header.scss';
.sub-nav {
  // width: 100%;
  // min-width: 960px;
  padding: 19px 0;
  position: fixed;
  right: 100px;
  top: 0;
  z-index: 9;
  .sub-nav-warp {
    padding-right: 310px;
  }
}
</style>
